import { useGroupStudentsContext } from "../../GroupStudentsContext/GroupStudentsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MarkingList = () => {
  const { currentCurriculum } = useGroupStudentsContext();
  return (
    <div className="px-2 py-1 flex flex-col justify-start overflow-auto bg-white h-12 max-w-150px min-w-150px relative">
      {currentCurriculum?.marking
        ?.sort((a, b) => a.value - b.value)
        ?.map((m) => (
          <div
            key={`key-marking-${m._id}`}
            className="text-xs flex gap-1 items-center rounded"
          >
            <FontAwesomeIcon icon="square" style={{ color: m.primaryColor }} />
            <span style={{ color: m.secondaryColor }} className="text-sm">
              {m.name}
            </span>
          </div>
        ))}
    </div>
  );
};
